import OSS from 'ali-oss';
import { EU_SITE } from '@/constants';

const getStsHost = (locale: string) => ([...EU_SITE, 'za'].includes(locale) ? process.env.NEXT_PUBLIC_STS_HOST_EU : process.env.NEXT_PUBLIC_STS_HOST);

export const uploadFileToOss = async (file: File, locale: string): Promise<string> => {
    const HOST_STS = getStsHost(locale);

    const [json1, json2] = await Promise.all([
        fetch(`${HOST_STS}/system/oss/fileUpload/prepareSts`, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then((r) => r.json()),
        fetch(`${HOST_STS}/system/oss/fileUpload/stsServer`, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }).then((r) => r.json()),
    ]);

    if (json1?.code !== '0' || json2?.StatusCode !== '200') {
        throw new Error('OSS initialization failed');
    }

    const { AccessKeyId: accessKeyId, AccessKeySecret: accessKeySecret, SecurityToken: stsToken } = json2;
    const { bucket, region } = json1.data;

    const client = new OSS({ region, accessKeyId, accessKeySecret, stsToken, bucket });
    const path = `/website/service-renewal/${locale}/${Date.now()}/${file.name}`;
    const res = await client.put(path, file);
    return res.url as string;
};
